import { useEffect, useState } from 'react'
import Stack from '@mui/material/Stack'
import Type from 'components/Type'
import Icon from 'components/Icon'
import Divider from 'components/Divider'
import Paper from 'components/Paper'
import TextButton from 'components/TextButton'
import TooltipMenu from 'components/TooltipMenu'
import CreditCardInput, { CARDS } from 'components/CreditCardInput'
import { ReactComponent as IconStar } from 'icons/Star.svg'
import { 
  useCorporateExternalCards,
  useExternalCards,
} from 'utils/accountHooks'

export const Card = ({
  unique_id,
  card_brand,
  last_four,
  allowEdit,
  isPrimary,
  onRemoveCard,
}) => {

  return (
    <Stack
      sx={theme => theme.internalMixins.columns({ gap: 1, justify: 'space-between' })}
    >
      <Stack
        sx={theme => theme.internalMixins.columns({ gap: 1 })}
      >
        <Stack
          sx={theme => ({
            display: 'inline-grid',
            placeItems: 'center',
            placeContent: 'center',
            width: 70,
            height: 40,
            overflow: 'hidden',
            borderRadius: '6px',
            border: theme.globals.border.neutralCool_300,
            borderWidth: '2px',
            bgcolor: 'background.paper.main',
          })}
        >
          <Icon
            icon={CARDS[card_brand?.toLowerCase()] || 'CardGeneric'}
            height="15"
            width="45"
          />
        </Stack>
        <Stack>
          <Type
            variant="dataSmall"
            color="neutralCool_700"
          >
            <strong>{card_brand}</strong> ending in {last_four}
          </Type>
          {/* {allowEdit && isPrimary && (
            <Type variant="labelSubatomicTertiary" color="primaryHue">
              <span style={{ fontSize: 15, marginRight: -5 }}>★</span>{' Primary'}
            </Type>
          )} */}
        </Stack>
      </Stack>
      {allowEdit && (
        <TooltipMenu
          hideWhenEmpty
          // actions={[
          //   {
          //     label: (
          //       <Stack
          //         display="grid"
          //         gap={0.5}
          //         gridAutoFlow="column"
          //         alignItems="center"
          //       >
          //         <IconStar />
          //         <div>
          //           Mark as Primary
          //         </div>
          //       </Stack>
          //     )
          //   },
          // ]}
          errorActions={[
            {
              label: 'Remove card',
              action: () => onRemoveCard(unique_id),
            },
          ]}
        />
      )}
    </Stack>
  )
}

const StoredCreditCard = ({
  isCorporate,
  primaryCard,
  externalCards,
  hasLinkedCard,
  onSetCCData,
}) => {
  const [editMode, setEditMode] = useState(false)
  const [recentCardID, setRecentCardID] = useState(primaryCard?.unique_id)

  const handleInvalid = () => {
    onSetCCData(editMode || !hasLinkedCard ? null : {
      saved_card_uid: recentCardID,
    })
  }

  useEffect(() => {
    if (primaryCard?.unique_id && !editMode) {
      onSetCCData({
        saved_card_uid: recentCardID || primaryCard?.unique_id,
      })
    }
  }, [
    primaryCard?.unique_id,
    editMode,
  ])

  return (
    <Stack>
      {!editMode && hasLinkedCard && (
        <Stack
          sx={theme => theme.internalMixins.columns({ gap: 1, justify: 'space-between' })}
        >
          <Card
            {...primaryCard}
          />
          <TextButton
            color="tertiary"
            onClick={() => setEditMode(true)}
          >
            Change
          </TextButton>
        </Stack>
      )}
      {(editMode || !hasLinkedCard) && (
        <Stack
          gap={2}
        >
          <Stack
            gap={2}
          >
            <Stack
              sx={theme => theme.internalMixins.columns({ gap: 1, justify: 'space-between' })}
            >
              <Type
                variant="p"
              >
                Add payment method
              </Type>
              {hasLinkedCard && (
                <TextButton
                  color="neutralCool_700"
                  onClick={() => setEditMode(false)}
                >
                  Cancel
                </TextButton>
              )}
            </Stack>
            <CreditCardInput
              isCorporate={isCorporate}
              creditCardInputProps={{
                splitName: true,
              }}
              onValid={onSetCCData}
              onInvalid={handleInvalid}
            />
          </Stack>
          {externalCards?.length > 1 && (
            <>
              <Divider
                color="neutral_200"
              />
              <Stack
                gap={2}
              >
                <Type
                  variant="p"
                >
                  Saved cards
                </Type>
                {externalCards?.map((o, idx) => (
                  <Paper
                    tabindex="0"
                    mixin="paperButton"
                    onClick={() => {
                      setRecentCardID(o.unique_id)
                      // onSetCCData({ saved_card_uid: o.unique_id })
                      setEditMode(false)
                    }}
                  >
                    <Stack
                      idx={o.unique_id}
                      py={1}
                      px={1.5}
                      sx={theme => theme.internalMixins.columns({ gap: 1, justify: 'space-between' })}
                    >
                      <Card
                        {...o}
                      />
                      <TextButton
                        color="tertiary"
                      >
                        Select
                      </TextButton>
                    </Stack>
                  </Paper>
                ))}
              </Stack>
            </>
          )}
        </Stack>
      )}
    </Stack>
  )
}

export const CorporateStoredCreditCard = props => {
  const {
    primaryCard,
    hasLinkedCard,
  } = useCorporateExternalCards()

  return (
    <StoredCreditCard
      {...props}
      isCorporate
      primaryCard={primaryCard}
      hasLinkedCard={hasLinkedCard}
    />
  )
}

export const UserStoredCreditCard = props => {
  const {
    primaryCard,
    externalCards,
    hasLinkedCard,
  } = useExternalCards()

  return (
    <StoredCreditCard
      {...props}
      primaryCard={primaryCard}
      externalCards={externalCards}
      hasLinkedCard={hasLinkedCard}
    />
  )
}

export default StoredCreditCard